import { useEffect, useRef } from 'react';
import { useT } from '../i18n';
import { Btn } from './ui';

/**
 * Donačtení další stránky seznamu (fáze 15): tlačítko + automatické donačtení, když se
 * sentinel dostane do výřezu (IntersectionObserver; bez něj – jsdom – zůstává jen tlačítko).
 */
export function LoadMore({
  hasMore,
  loading,
  onMore,
  label,
}: {
  hasMore: boolean | undefined;
  loading: boolean;
  onMore: () => void;
  label?: string;
}) {
  const t = useT();
  const text = label ?? t('common.loadMore');
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || !hasMore || typeof IntersectionObserver === 'undefined') return;
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting) && !loading) onMore();
    });
    io.observe(el);
    return () => io.disconnect();
  }, [hasMore, loading, onMore]);
  if (!hasMore) return null;
  return (
    <div ref={ref} className="load-more">
      <Btn sm onClick={onMore} disabled={loading}>
        {loading ? t('common.loading') : text}
      </Btn>
    </div>
  );
}
